import { ChevronButton, LabeledIcon } from '@/shared/components';
import type { AccountCreateButtonType } from '@/shared/types';
import { useTranslation } from 'react-i18next';
import { tv } from 'tailwind-variants';

type Props = {
  account: AccountCreateButtonType;
  onClick: () => void;
};

const accountButton = tv({
  slots: {
    button: 'px-[2.4rem] py-[1.6rem] bg-background hover:bg-stroke',
    title: 'headline4',
    description: 'text-secondary p3 text-balance',
    icon: 'border-stroke',
    iconBg: '',
  },
  variants: {
    disabled: {
      true: {
        button: 'bg-stroke pointer-events-none',
        title: 'text-secondary',
        iconBg: 'text-secondary',
      },
    },
  },
  defaultVariants: {
    disabled: false,
  },
});

const OpenAccountButton = ({ account, onClick }: Props) => {
  const { t } = useTranslation();
  const { title, description, icon, label, isPending, isAvailable } = account;
  const disabled = !isAvailable || isPending;

  const {
    button: buttonClassName,
    title: titleClassName,
    description: descriptionClassName,
    icon: iconClassName,
    iconBg: iconBgClassName,
  } = accountButton({
    disabled,
  });

  return (
    <ChevronButton
      icon={
        <LabeledIcon
          icon={icon}
          label={!disabled ? label : undefined}
          className={iconBgClassName()}
          iconClassName={iconClassName()}
        />
      }
      onClick={onClick}
      className={buttonClassName()}>
      <div className="flex flex-col gap-[0.2rem]">
        <h4 className={titleClassName()}>{title}</h4>
        <p className={descriptionClassName()}>
          {isPending
            ? t('openAccount.pending')
            : !isAvailable
              ? t('openAccount.limitReached')
              : description}
        </p>
      </div>
    </ChevronButton>
  );
};

export { OpenAccountButton };
